import * as channelsApi from '@/network/api/channels.api.js'

/** Request Channels List
@return { promise }
*/
export const requestChannelsList = async (context, payload) => {
    const res = await channelsApi.getChannelsList(payload)

    if (res) {
        const data = res.data.data
        context.commit('SAVE_CHANNELS_LIST', data)
    }
    return res
}

/** Update Channels List
@return { promise }
*/
export const updateChannel = async (context, payload) => {
    const res = await channelsApi.updateChannelActiveState(payload)

    if (res) {
        payload.toggleDate = res.data.data.channelToggleDate
        context.commit('UPDATE_CHANNELS_LIST', payload)
    }
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
